// src/components/popups/FeatureNotAvailableDrawer.js
import React from 'react';
import './FeatureNotAvailableDrawer.css';

export default function FeatureNotAvailableDrawer({
  open,
  title = 'Feature Not Available Yet',
  message = 'Reward code trading is coming soon. This feature will allow users to trade digital codes in the marketplace for Pi.',
  onClose = () => {},
}) {
  if (!open) return null;

  return (
    <div className="fna-backdrop" onClick={onClose}>
      <div className="fna-drawer" onClick={(e) => e.stopPropagation()}>
        <div className="fna-handle" />

        <div className="fna-header">
          <div className="fna-title">{title}</div>
          <button className="fna-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <div className="fna-body">
          <div className="fna-msg">{message}</div>
        </div>

        <div className="fna-actions">
          <button className="fna-btn primary" onClick={onClose}>
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
